import React from 'react';

export default function EndedScreen({ roomCode, galleryAvailable, celebration }) {
  return (
    <div className="screen">
      <div style={{ fontSize: 52, marginBottom: 16 }}>{celebration ? '🎊' : '👋'}</div>
      <div className="brand">{celebration ? "That's a wrap" : 'Showing Ended'}</div>
      <div className="tagline">
        {celebration
          ? <>The live stream has ended.<br />Thank you for being part of it.</>
          : <>Your agent has ended this showing.<br />Thanks for watching.</>}
      </div>

      {galleryAvailable && (
        <a
          href={`/gallery/${roomCode}`}
          className="btn"
          style={{ marginTop: 20, display: 'inline-block', textDecoration: 'none' }}
        >
          {celebration ? '📸 Relive it — open the album' : '📸 View Listing Photos'}
        </a>
      )}

      <div className="card" style={{ marginTop: 32, padding: '24px', maxWidth: 320, width: '100%' }}>
        <div style={{ fontSize: 13, color: '#6A85A0', marginBottom: 12 }}>
          {celebration ? 'Hosting a celebration?' : 'Are you an agent?'}
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#00D4FF', letterSpacing: 2, marginBottom: 8 }}>
          Peekr
        </div>
        <div style={{ fontSize: 13, color: '#6A85A0', marginBottom: 16 }}>
          {celebration
            ? 'Stream it live to family anywhere — no app for them. Keepsake album after.'
            : 'Run live property showings buyers watch from anywhere.'}
        </div>
        <a
          href={celebration ? '/celebrate.html' : 'https://getpeekr.com'}
          className="btn"
          style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }}
        >
          {celebration ? 'Peekr for Celebrations' : 'Get Peekr for Agents'}
        </a>
      </div>

      <div className="sub" style={{ marginTop: 24 }}>
        getpeekr.com
      </div>
    </div>
  );
}
